// src/hooks/useToast.js
import { toast } from 'react-toastify';

export function useToast() {
  const toastSuccess = (message = 'Operation successful') =>
    toast.success(message, {
      position: "top-center",
      autoClose: 3000,
    });

  const toastError = (message = 'An error occurred') =>
    toast.error(message, {
      position: "top-center",
      autoClose: 5000,
    });

  const toastInfo = (message = 'Information') =>
    toast.info(message, {
      position: "top-center",
      autoClose: 4000,
    });

  const toastWarning = (message = 'Warning') =>
    toast.warning(message, {
      position: "top-center",
      autoClose: 4000,
    });

  return {
    toastSuccess,
    toastError,
    toastInfo,
    toastWarning,
  };
}
